import * as React from 'react'
import { styled } from 'styled-components'
import { Accordion } from 'react-bootstrap'
import * as domain from '@packages/domain'
import { TitleWithOptions } from './TitleWithOptions'

// Styled components
const StepContainer = styled(Accordion.Item)`
  margin-bottom: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;

  pointer-events: none;
  opacity: 0.6;
`

const StyledAccordionHeader = styled(Accordion.Header)`
  .accordion-button {
    display: flex;
    align-items: center;

    background-color: var(--bs-white);
  }
`

export interface PreviewProps {
  step: domain.Step.Type
  eventKey: string
}

export const Preview: React.FC<PreviewProps> = ({ step, eventKey }) => {
  return (
    <StepContainer eventKey={eventKey} id={eventKey}>
      <StyledAccordionHeader>
        <TitleWithOptions step={step} />
      </StyledAccordionHeader>
    </StepContainer>
  )
}
